import { useCallback, useEffect, useState } from 'react';

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/practice/offices`;

export async function officesCall(path = '', options = {}) {
  const res = await fetch(`${BASE}${path}`, {
    ...options,
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('dentalToken')}` },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(typeof data.detail === 'string' ? data.detail : 'Something went wrong. Please try again.');
  return data;
}

export function useOffices() {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const reload = useCallback(async () => {
    try { setData(await officesCall()); setError(''); } catch (e) { setError(e.message); }
  }, []);
  useEffect(() => { reload(); }, [reload]);
  const open = (data?.offices || []).filter((o) => o.isActive !== false);
  return { data, error, reload, open, multi: open.length > 1 };
}

export const officeName = (offices, id) => {
  const list = offices || [];
  return (list.find((o) => o.id === id) || list.find((o) => o.isPrimary))?.name || '';
};
